import React from 'react'

import { Button, useToggle } from '../../../module'
import { type TimeframeProps } from '../TimeframesType'
import styles from '../_timeframe-filter.module.scss'
import { c } from '../../../translations/LibraryTranslationService'

type TimeframeButtonProps = {
  updateTimeframe: (el: TimeframeProps) => void
  el: TimeframeProps
  timeframe: TimeframeProps
  disabled: boolean
  customDisplay?: string
  timeframeKey?: string
}

type TimeframeKeyProps = {
  display: string
}

const TimeframeButton = ({
  updateTimeframe,
  el,
  timeframe,
  disabled,
  customDisplay,
  timeframeKey = 'display',
}: TimeframeButtonProps): React.JSX.Element => {
  const isMultiLanguageSupportToggleEnabled = useToggle(
    'timeframe_multi_language_support',
  )

  let isSelected = false

  if (isMultiLanguageSupportToggleEnabled) {
    const timeFrameKeyValue =
      timeframe[timeframeKey as keyof TimeframeKeyProps]?.toLowerCase?.()
    // Check if the selected timeframe type matches the button's timeframe type
    const isSameType = timeframe?.type === el?.type

    // If customDisplay is provided, use it to determine if the button is selected
    // Otherwise, compare the translated display value with the button's display value
    isSelected = customDisplay
      ? timeFrameKeyValue === customDisplay.toLowerCase() && isSameType
      : c(timeFrameKeyValue).toLowerCase() === el?.display.toLowerCase() &&
        isSameType
  } else {
    isSelected =
      timeframe[timeframeKey as keyof TimeframeKeyProps]?.toLowerCase?.() ===
        (customDisplay?.toLowerCase?.() || el.display?.toLowerCase?.()) &&
      timeframe?.type === el?.type
  }
  return (
    <Button
      as='unstyled'
      className={`${styles.filterButton} ${isSelected ? styles.active : ''} ${
        el.customClass ? el.customClass : ''
      } ${disabled ? styles.disabled : ''}`}
      key={el.id}
      disabled={disabled}
      onClick={() => {
        !isSelected && !disabled && updateTimeframe(el)
      }}
    >
      {el.display}
    </Button>
  )
}

export default TimeframeButton
